import { call, put } from 'redux-saga/effects';

import * as types from './dialog.types';
import * as actions from './dialog.actions';

export function* openDialog(dialogKey: types.IDialogKey, props: types.IDialogInstanceProps | null) {
  // Store props before opening so the first paint never sees isOpen + stale null props (cleared on close).
  yield put(actions.storeDialogProps(dialogKey, props));
  yield put(actions.storeIsDialogOpen(dialogKey));
}

export function* closeDialog(dialogKey: types.IDialogKey) {
  yield put(actions.clearIsDialogOpen(dialogKey));

  yield call(() => new Promise((res) => setTimeout(res, 200)));
  yield put(actions.clearDialogProps(dialogKey));
}

export function* setDialogCloseable(dialogKey: types.IDialogKey) {
  yield put(actions.storeIsDialogCloseable(dialogKey));
}

export function* setDialogNotCloseable(dialogKey: types.IDialogKey) {
  yield put(actions.clearIsDialogCloseable(dialogKey));
}
